import axios from 'axios'
const baseUrl = 'https://api.phkj1.store'

// 管理员登录
export function adminLogin(data) {
  return axios.post(`${baseUrl}/api/admin/login`, data)
}

// 用户列表
export function getUserList(params) {
  return axios.get(`${baseUrl}/api/admin/users`, { params })
}

// 帖子列表
export function getPostList(params) {
  return axios.get(`${baseUrl}/api/admin/posts`, { params })
}

// 删除帖子
export function delPost(id) {
  return axios.delete(`${baseUrl}/api/admin/post/${id}`)
}

// 评论列表
export function getCommentList(params) {
  return axios.get(`${baseUrl}/api/admin/comments`, { params })
}

// 铭牌相关
export function getBadgeList() {
  return axios.get(`${baseUrl}/api/admin/badges`)
}
export function addBadge(data) {
  return axios.post(`${baseUrl}/api/admin/badge`, data)
}
export function delBadge(id) {
  return axios.delete(`${baseUrl}/api/admin/badge/${id}`)
}

//教练管理接口
export function getCoachList(){
  return axios.get(`${baseUrl}/api/admin/coach/list`)
}
export function addCoach(data){
  return axios.post(`${baseUrl}/api/admin/coach/add`, data)
}
export function editCoach(id,data){
  return axios.put(`${baseUrl}/api/admin/coach/${id}`, data)
}
export function delCoach(id){
  return axios.delete(`${baseUrl}/api/admin/coach/${id}`)
}

//站点全局设置接口
export function getSiteConfig(){
  return axios.get(`${baseUrl}/api/admin/siteconfig/get`)
}
export function saveSiteConfig(data){
  return axios.post(`${baseUrl}/api/admin/siteconfig/save`, data)
}
